stimulusApp.register(
  "pricing-view-mode",
  class extends Stimulus.Controller {
    static values = {
      url: { type: String },
    }

    change() {
      const value = this.element.querySelector("input:checked").value

      RailsRequest.post(this.urlValue, { body: { value } })

      document.body.dataset.pricingViewMode = value
    }
  },
)
